<template>
  <div class="d-flex flex-column align-items-center parent-wrapper">
    <div :style="styles" class="image-wrapper">
      <img :src="product.backgroundImage" class="product-image img-fluid w-100" :style="imageStyles" />
    </div>
    <div class="title" v-html="product.title"></div>
  </div>
</template>
<script>
export default {
  name: "selected-product-show",
  data () {
    return {
      product: {}
    };
  },
  props: {
    error: String,
    styles: {
      type: Object,
      default: () => {}
    },
    imageStyles: {
      type: Object,
      default: () => {}
    },
    selectionComponentId: String
  },
  mounted () {
    if (
      this.$store.state.componentStatus[this.selectionComponentId] &&
      this.$store.state.componentStatus[this.selectionComponentId].selected
    )
      this.product = this.$store.state.componentStatus[
        this.selectionComponentId
      ].selected;
    const objectIsEmpty = Object.keys(this.product).length === 0;
    if (objectIsEmpty) {
      this.showModal(`<div class='pb-5'>${this.error}</p></div>`);
      this.goToPage("home", this);
    }
  }
};
</script>
<style lang="scss" scoped>
.image-wrapper{
  width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  opacity: 1;
  transition: 0.4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.title {
  text-align: center;
}
.parent-wrapper{
  padding: 0;
}
.product {
  // height: 180px;
  // width: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 16px;
  margin-top: 50px;
  position: relative;
  background-size: cover;
  background: #ffffff;
  border: 1px solid #dddfe1;
  box-sizing: border-box;
  border-radius: 4px;

  .product-image {
    width: 100%;
    object-fit: cover;
    padding: 30px 10px 8px 10px;
  }

  &.active,
  &:hover {
    border: 1px solid #8b8b8b;
    box-sizing: border-box;
    border-radius: 4px;
    transition: 0.4s ease-in-out;
  }

  &.notSelectable {
    opacity: 0.6;
    -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
    filter: grayscale(100%);
  }
  .isSelectedBox {
    border-radius: 5px;
    position: absolute;
    top: 16px;
    left: 16px;
    user-select: none;
    svg {
      position: absolute;
    }
  }
}
</style>